<template>
  <v-card>
    <v-form>
      <v-container>
        <fieldset>
          <legend>Work Details</legend>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Class</label>
              <v-select
                v-model="selectedClass"
                :items="classes"
                label="Choose Class"
                placeholder="Choose Class"
                solo
                single-line
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Subject</label>
              <v-select
                v-model="selectSubject"
                :items="subjects"
                label="Choose Subject"
                placeholder="Choose Subject"
                solo
                single-line
              ></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Tutor</label>
              <v-select
                v-model="selectedTutor"
                :items="tutors"
                label="Choose Tutor"
                placeholder="Choose Tutor"
                solo
                single-line
              ></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Session Code</label>
              <v-select
                v-model="selectedSession"
                :items="sessions"
                label="Choose Session Code"
                placeholder="Choose Session Code"
                solo
                single-line
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <label class="custom-label">Work File</label>
              <v-file-input
                label="Choose File"
                accept="file/pdf"
                persistent-hint
                hint="File Should be PDF"
                show-size
                counter
                multiple
                chips
                solo
              ></v-file-input>
            </v-col>
          </v-row>
        </fieldset>

        <v-row>
          <v-col cols="12">
            <v-btn color="#6A158E" dark>Save</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: "WorkForm",
  data() {
    return {
      time: null,
      menu2: false,
      rating: 4,
      select: "",
      selectedGroup: "",
      groups: ["Group 01", "Group 02", "Group 03", "Group 04", "Group 05"],
      selectedSession: "",
      sessions: [
        "Session 101",
        "Session 102",
        "Session 103",
        "Session 104",
        "Session 105"
      ],
      selectedType: "",
      workTypes: ["Class Work", "Home Work"],
      selectedGroup: "",
      selectedClass: "",
      classes: ["6th", "7th", "A-Level", "O-Level"],
      selectedTutor: "",
      tutors: ["Irfan Ikram", "Ahmad Fraz", "Sheikh Rasheed", "Afzal Ahmad"],
      selectSubject: "",
      subjects: ["English", "Math", "Science", "Physics", "Chemistry"]
    };
  }
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;
  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }
}
</style>